import { Chip } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import {
  AutocompleteInput,
  Datagrid, DateField,
  FunctionField,
  List, SelectInput,
  TextField,
  TextInput
} from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import dataProvider from "../../providers/data-provider";

export function QuizAssessmentQuestionList(props) {
  const [tags, setTags] = useState([]);
  const [themes, setThemes] = useState([]);

  const appContext = useContext(AppContext)

  useEffect(() => {
    dataProvider.get('quiz-assessment-question', 'tags').then(res =>
      setTags(res.data.map(tag => ({ id: tag, name: tag })))
    );

    dataProvider.get('themes', '').then(res => setThemes(res.data.data));
  }, []);

  const filters = [
    <AutocompleteInput
      source="themeId"
      emptyText="Todos"
      clearAlwaysVisible={true}
      fullWidth
      label={'Área'}
      choices={themes}
    />,
    <AutocompleteInput
      style={{ width: '550px' }}
      source="tags"
      label="Tags"
      emptyText="Todos"
      choices={tags}
      multiple
    />,
    <TextInput variant={'standard'} source={'question'} label={'Trecho do enunciado'} />,
    <TextInput source={'code'} alwaysOn label={'Código'} />,
    <SelectInput alwaysOn source="owner" label="Propriedade" choices={[
      { id: 'mine', name: 'Minhas Questões' },
      { id: 'pre', name: 'Questões do Juristta' },
      { id: 'all', name: 'Todas Questões' },
    ]} />
  ];

  return (
    <div style={{ display: 'flex', gap: 20 }}>
      <div style={{ flex: 3 }}>
        <List
          // sort={{ field: 'source.name', order: 'ASC' }}
          filters={filters}
          exporter={false}
          bulkActionButtons={false}
          filterDefaultValues={{ owner: 'all' }}
          {...props}
        >
          <Datagrid rowClick={'edit'}>
            <TextField source="code" label="Código" />
            <FunctionField label="Área" render={record => record.theme?.name} />
            <DateField label="Data Criação" source={'createdAt'} />
            <FunctionField label={'Tags'} render={record => <TagsField record={record} />} />
            <FunctionField label="Questão" render={record => <QuestionField record={record} />} />
            <FunctionField label="" render={record => <TypeQuestionField record={record} />} />
          </Datagrid>
        </List>
      </div>

      {/*<div style={{flex: 1}}>*/}
      {/*  <QuestionResumeTable record={props.record} />*/}
      {/*</div>*/}
    </div>
  )
}


const TagsField = ({ record }) => {
  return (
    <>
      {record.tags.map(item => (
        <Chip key={item} label={item} />
      ))}
    </>
  )
}

const QuestionField = ({ record }) => {
  if (record.question?.length > 100) {
    return record.question.substring(0, 100) + '...';
  }
  return record.question;
}

const TypeQuestionField = ({ record }) => {
  const appContext = useContext(AppContext)
  if (record.ownerId === appContext.currentUser.id) {
    return <Chip color={'primary'} label={'Minha Questão'} />;
  }
  return <Chip color={'default'} label={'Questão do Juristta'} />;
}

